import * as React from "react";
const SvgFiRrShieldCross = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.574 2.126 12.315.051a1 1 0 0 0-.63 0L5.427 2.126A4.99 4.99 0 0 0 2 6.872v5.171c0 6.563 7.005 10.577 9.153 11.651l.403.201a1 1 0 0 0 .82.033l.417-.168C14.953 22.891 22 19.478 22 12.043V6.872a4.99 4.99 0 0 0-3.426-4.746M20 12.043c0 6.181-6.087 9.111-7.953 9.861C10.159 20.96 4 17.459 4 12.043V6.872c0-1.296.826-2.44 2.056-2.848L12 2.053l5.944 1.971A3 3 0 0 1 20 6.872z"
    />
    <path
      fill="#062147"
      d="M17 9h-4V5a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v7.5a1 1 0 0 0 2 0V11h4a1 1 0 0 0 0-2"
    />
  </svg>
);
export default SvgFiRrShieldCross;
